import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getColor } from '@panel/commons/core/themev3';
import { useDispatch } from 'react-redux';
import { FilterOperations } from '../../../ducks/filter';
import useUrlSearchParams from '../hooks/useUrlSearchParams';

function EmptySearch() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { cleanUrlFilters } = useUrlSearchParams();

  const handleClick = () => {
    dispatch(FilterOperations.reset());
    cleanUrlFilters();
  };

  return (
    <Wrapper data-panel='panel-empty-search'>
      <Label>
        {t('panel.emptySearch.mainLabel')}
        <ClearCTA onClick={handleClick}> {t('panel.emptySearch.CTA')}</ClearCTA>
      </Label>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  width: 100%;
`;

const ClearCTA = styled.a`
  color: ${getColor('primary')};
  font-weight: bold;
  cursor: pointer;
`;

const Label = styled.p`
  max-width: 600px;
  white-space: normal;
  font-family: Hind;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  text-align: center;
  padding: 30px;
`;

export default EmptySearch;
